import React from "react";

const date = new Date();
const year = date.getFullYear();

// noinspection SpellCheckingInspection
const APPCONFIG = {
	brand: 'FFL Boss',
	image: <img src={'/assets/images/ffllogo.png'} alt={'FFL Boss'} />,
	year,
	copyright: '2011',
	productLink: 'https://app.fflboss.com',
	reCAPTCHA: '6LcLpdYZAAAAAJ7GAGkirP1XxLYvy4DhHzg_SuT4',
	turnstile: (window.location.hostname === 'beta.fflboss.com' || window.location.hostname === 'application.fflboss.com') ?
		'0x4AAAAAAEOYZTJ7QIR-vme-' :
		(window.location.hostname === 'app.fflboss.com' ?
			'0x4AAAAAAEOYappwYWlRFdVv' :
			'0x4AAAAAAAXj52ltzefTqfQQ'),
	settings: {
		isDev: () => {
			return !process.env.production
		},
		adminURL: () => {
			return window.location.hostname === 'beta.fflboss.com' ?
				"https://beta.admin.fflboss.com" :
				( window.location.hostname === 'app.fflboss.com' ?
					'https://admin.fflboss.com' :
					'https://dev.admin.fflboss.com:4443' );
		},
		apiURL: () => {
			if( APPCONFIG.settings.apiURLOverride ) {
				return APPCONFIG.settings.apiURLOverride;
			}
			return (window.location.hostname === 'beta.fflboss.com' || window.location.hostname === 'application.fflboss.com') ?
				"https://beta.api.fflboss.com" :
				(window.location.hostname === 'app.fflboss.com' ? 'https://va1.api.fflboss.com' : 'https://dev.api.fflboss.com');
		},
		isProductionAPI: () => {
			return APPCONFIG.apiURL !== 'https://beta.api.fflboss.com' && APPCONFIG.apiURL !== 'https://dev.api.fflboss.com';
		},
		apiURLOverride: null,
		apiURLs: [
			'https://dev.api.fflboss.com',
			'https://beta.api.fflboss.com',
			'https://va1.api.fflboss.com',
		],
		apiVersion: 'v819'
	}
};
export default APPCONFIG;
